export default __webpack_public_path__ + "static/media/vyhled-na-skaly.e63bd3ba.jpeg";